import React, { useState } from "react";
import { API_URL } from "../helpers";
import Input from "../components/Input";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Step1 = ({ charityId, update }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		charityId,
	});
	const [msg, setMsg] = useState({});

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/charitySignin1`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				update("signinToken", json.token);
				update("email", json.email);
				update("step", 2);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
		>
			<h3 style={{ marginTop: "0" }}>
				Chair, Vice Chair or Additional Dashboard Charity Contact
			</h3>

			<div className="form-group">
				<Input
					name="email"
					label="Email"
					reqd={true}
					value={names.email || ""}
					update={handleUpdate}
					errors={errors}
				/>
				<div />
			</div>

			<div className="msg-submit">
				{msg.type && <Msg data={msg} />}

				<div
					className={
						msg.type === "working" || msg.type === "success"
							? "hidden"
							: "submit-container"
					}
				>
					<Submit path="" left="" submit="Submit Email Address" />
				</div>
			</div>
		</form>
	);
};

export default Step1;
